/** One part of a deep-thinking note: the model writes its reasoning as parts,
 *  each opening with a bold title on its own line. The note's first part has
 *  no title here: its title is the step's label. */
export interface ThoughtSection {
  readonly heading: string;
  readonly body: string;
}

/** A line that is nothing but a bold title: `**Analyzing eligibility**`. */
const TITLE_LINE = /^\s*\*\*([^*\n]+?)\*\*\s*$/;

/**
 * Split a note into its parts at each standalone bold title line. Text before
 * the first title is an untitled first part; empty parts are dropped. A note
 * without titles is one untitled part.
 */
export function splitThoughtSections(text: string): ThoughtSection[] {
  const sections: ThoughtSection[] = [];
  let heading = '';
  let lines: string[] = [];
  const flush = () => {
    const body = lines.join('\n').trim();
    if (heading.length > 0 || body.length > 0) {
      sections.push({ heading, body });
    }
  };
  for (const line of text.split('\n')) {
    const title = TITLE_LINE.exec(line);
    if (title) {
      flush();
      heading = title[1]?.trim() ?? '';
      lines = [];
    } else {
      lines.push(line);
    }
  }
  flush();
  return sections;
}
